document.addEventListener('DOMContentLoaded', () => {
    const inputsFiltro = document.querySelectorAll('.inputFiltroGestion');
    if (!inputsFiltro.length) return;

    function normalizarTexto(texto) {
        return texto
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
    }

    function debounce(callback, delay = 250) {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => callback(...args), delay);
        };
    }

    function obtenerFilasDatos(tbody) {
        const filas = tbody.querySelectorAll('tr');
        const filasDatos = [];
        filas.forEach(fila => {
            if (fila.classList.contains('filaSinResultados')) return;
            if (fila.querySelector('.tdVacio')) return;
            filasDatos.push(fila);
        });
        return filasDatos;
    }

    function actualizarFilaSinResultados(tabla, tbody, visibles, criterio) {
        let filaSinResultados = tbody.querySelector('.filaSinResultados');
        const mostrar = visibles === 0 && criterio !== '';

        if (mostrar && !filaSinResultados) {
            const totalColumnas = tabla.querySelectorAll('thead th').length;
            filaSinResultados = document.createElement('tr');
            filaSinResultados.classList.add('filaSinResultados');
            const celda = document.createElement('td');
            celda.colSpan = totalColumnas > 0 ? totalColumnas : 1;
            celda.classList.add('tdVacio');
            celda.textContent = 'No se encontraron resultados para el filtro.';
            filaSinResultados.appendChild(celda);
            tbody.appendChild(filaSinResultados);
        }

        if (filaSinResultados) {
            filaSinResultados.style.display = mostrar ? '' : 'none';
        }
    }

    function filtrarTablaGestion(input) {
        const vista = input.closest('.vistaGestion');
        if (!vista) return;
        const tabla = vista.querySelector('.tablaModal');
        if (!tabla) return;
        const tbody = tabla.querySelector('tbody');
        if (!tbody) return;

        const filasDatos = obtenerFilasDatos(tbody);
        if (!filasDatos.length) return;

        const criterio = normalizarTexto(input.value.trim());
        let visibles = 0;

        filasDatos.forEach(fila => {
            const textoFila = normalizarTexto(fila.textContent);
            const coincide = criterio === '' || textoFila.includes(criterio);
            fila.style.display = coincide ? '' : 'none';
            if (coincide) visibles++;
        });

        actualizarFilaSinResultados(tabla, tbody, visibles, criterio);
    }

    inputsFiltro.forEach(input => {
        input.addEventListener('input', debounce(() => filtrarTablaGestion(input), 250));
    });
});
